import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DOM from 'react-dom-factories';

export default class DateTimePickerDays extends Component {
  static propTypes = {
    prevIcon: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    nextIcon: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    value: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    viewDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    addTime: PropTypes.func,
    showView: PropTypes.func,
    renderDay: PropTypes.func,
    subtractTime: PropTypes.func,
    updateSelectedDate: PropTypes.func,
    timeFormat: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool ]),
    selectedDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    isValidDate: PropTypes.bool,
    showDayText: PropTypes.bool,
    showDayIcon: PropTypes.bool,
    dayRenderingAdditions: PropTypes.arrayOf(PropTypes.object),
  };

  constructor (props) {
    super(props);

    this.renderDay = this.renderDay.bind(this);
    this.renderDays = this.renderDays.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
    this.getDaysOfWeek = this.getDaysOfWeek.bind(this);
    this.alwaysValidDate = this.alwaysValidDate.bind(this);
    this.isDisabledFromTo = this.isDisabledFromTo.bind(this);
    this.updateSelectedDate = this.updateSelectedDate.bind(this);
    this.additionalDayRendering = this.additionalDayRendering.bind(this);
  }
  /**
   * Get a list of the days of the week
   * depending on the current locale
   * @return {array} A list with the shortname of the days
   */
  getDaysOfWeek (locale) {
    let days = locale._weekdaysShort;
    let first = locale.firstDayOfWeek();
    let dow = [];
    let i = 0;

    days.forEach(function (day) {
      dow[ (7 + i++ - first) % 7 ] = day;
    });

    return dow;
  }

  isDisabledFromTo (currentDate) {
    currentDate = moment(currentDate).toDate();
    let selectedDate = new Date(this.props.value);
    if (this.props.timeFormat) {
      currentDate.setHours(selectedDate.getHours());
      currentDate.setMinutes(selectedDate.getMinutes());
      currentDate.setSeconds(selectedDate.getSeconds());
    }

    let currentDateMilis = currentDate.getTime();

    if (this.props.minDate) {
      let minDate = new Date(this.props.minDate);
      let minDateMilis = minDate.getTime();

      if (currentDateMilis < minDateMilis) {
        return true;
      }
    }

    if (this.props.maxDate) {
      let maxDate = new Date(this.props.maxDate);
      let maxDateMilis = maxDate.getTime();

      if (currentDateMilis > maxDateMilis) {
        return true;
      }
    }

    return false;
  }

  additionalDayRendering (currentDate) {
    currentDate = moment(currentDate).toDate();
    let currentDateMilis = currentDate.getTime();

    if (this.props.dayRenderingAdditions && this.props.dayRenderingAdditions.length) {
      for (let i = 0; i < this.props.dayRenderingAdditions.length; i++) {
        let day = this.props.dayRenderingAdditions[ i ];
        if (!day || !day.date) return;
        let date = new Date(day.date);
        let dateMilis = date.getTime();
        if (dateMilis === currentDateMilis) {
          return day;
        }
      }
    }
    return '';
  }

  renderDays () {
    let date = this.props.viewDate;
    let selected = this.props.selectedDate && this.props.selectedDate.clone();
    let prevMonth = date.clone().subtract(1, 'months');
    let currentYear = date.year();
    let currentMonth = date.month();
    let weeks = [];
    let days = [];
    let renderer = this.props.renderDay || this.renderDay;
    let isValid = this.props.isValidDate || this.alwaysValidDate;
    let classes;
    let isDisabled;
    let dayProps;
    let currentDate;

    // Go to the last week of the previous month
    prevMonth.date(prevMonth.daysInMonth()).startOf('week');
    let lastDay = prevMonth.clone().add(42, 'd');

    while (prevMonth.isBefore(lastDay)) {
      classes = 'date-time-picker-day';
      currentDate = prevMonth.clone();

      if (
        (prevMonth.year() === currentYear && prevMonth.month() < currentMonth) ||
        prevMonth.year() < currentYear
      ) {
        classes += ' date-time-picker-old';
      } else if (
        (prevMonth.year() === currentYear && prevMonth.month() > currentMonth) ||
        prevMonth.year() > currentYear
      ) {
        classes += ' date-time-picker-new';
      }

      if (selected && prevMonth.isSame(selected, 'day')) {
        classes += ' date-time-picker-active';
      }

      if (prevMonth.isSame(moment(), 'day')) classes += ' date-time-picker-today';

      isDisabled = !isValid(currentDate, selected);

      if (!isDisabled) {
        isDisabled = this.isDisabledFromTo(currentDate);
      }

      let additionalConditions = this.additionalDayRendering(currentDate);
      if (this.props.dayRenderingAdditions && this.props.dayRenderingAdditions.length) {
        if (additionalConditions) {
          if (additionalConditions.type) {
            classes += ` date-time-picker-${additionalConditions.type}`;
          }

          /* if dayRenderingAdditions prop exist && there is aditional conditions,
          date must have enabled property otherwise it will be disabled */
          isDisabled = isDisabled || !additionalConditions.enabled;
        } else {
          /* if dayRenderingAdditions prop exist && there is no aditional conditions,
           all items will be disabled */
          isDisabled = true;
        }
      }

      if (isDisabled && !additionalConditions) classes += ' date-time-picker-disabled';

      dayProps = {
        key: prevMonth.format('M_D'),
        'data-value': prevMonth.date(),
        className: classes,
      };

      if (!isDisabled) dayProps.onClick = this.updateSelectedDate;

      days.push(renderer(dayProps, currentDate, additionalConditions, selected));

      if (days.length === 7) {
        weeks.push(DOM.tr({ key: prevMonth.format('M_D') }, days));
        days = [];
      }

      prevMonth.add(1, 'd');
    }

    return weeks;
  }

  updateSelectedDate (event) {
    this.props.updateSelectedDate(event, true);
  }

  renderDay (props, currentDate, additionalConditions, selected) {
    let day = currentDate.date();
    if (
      additionalConditions &&
      additionalConditions.text &&
      (this.props.showDayText || this.props.showDayIcon)
    ) {
      let icon = additionalConditions.icon ? additionalConditions.icon : null;
      let textProps = Object.assign({}, props);
      textProps.key += '-day-text';
      textProps.className += ' date-time-picker-day-text';
      let textIconProps = Object.assign({}, textProps);
      textIconProps.key += '-day-text-icon';
      textIconProps.className += '-icon';
      let dayProps = Object.assign({}, props);
      dayProps.className += '-day';
      dayProps.key += '-day';
      props.className += ' wrapper';

      let addditionToDayRender =
        icon && this.props.showDayIcon ?
          DOM.div(
            textProps,
            DOM.span(textIconProps, icon),
            DOM.span(textProps, additionalConditions.text)
          ) :
          this.props.showDayText ?
            DOM.div(textProps, DOM.span(textProps, additionalConditions.text)) :
            '';

      // DOM.div(props, DOM.div(dayProps, `${day}\n`), DOM.div(textProps, addditionToDayRender));
      return DOM.td(props, DOM.div(props, DOM.div(dayProps, `${day}`), addditionToDayRender));
    }

    props.className += ' wrapper';
    return DOM.td(props, DOM.div(props, day));
  }

  renderFooter () {
    if (!this.props.timeFormat) return '';

    let date = this.props.selectedDate || this.props.viewDate;

    return DOM.tfoot(
      { key: 'tf' },
      DOM.tr(
        {},
        DOM.td(
          {
            onClick: this.props.showView('time'),
            colSpan: 7,
            className: 'date-time-picker-time-toggle',
          },
          date.format(this.props.timeFormat || '')
        )
      )
    );
  }

  alwaysValidDate () {
    return 1;
  }

  render () {
    let footer = this.renderFooter();
    let date = this.props.viewDate;
    let locale = date.localeData();
    let tableChildren;

    tableChildren = [
      DOM.thead({ key: 'th' }, [
        DOM.tr({ key: 'h' }, [
          DOM.th(
            {
              key: 'p',
              className: 'date-time-picker-prev',
              onClick: this.props.subtractTime(1, 'months'),
            },
            DOM.span({}, this.props.prevIcon || '‹')
          ),
          DOM.th(
            {
              key: 's',
              className: 'date-time-picker-switch',
              onClick: this.props.showView('months'),
              colSpan: 5,
              'data-value': this.props.viewDate.month(),
            },
            locale.months(date) + ' ' + date.year()
          ),
          DOM.th(
            {
              key: 'n',
              className: 'date-time-picker-next',
              onClick: this.props.addTime(1, 'months'),
            },
            DOM.span({}, this.props.nextIcon || '›')
          ),
        ]),
        DOM.tr(
          { key: 'd' },
          this.getDaysOfWeek(locale).map(function (day, index) {
            return DOM.th({ key: day + index, className: 'dow' }, day);
          })
        ),
      ]),
      DOM.tbody({ key: 'tb' }, this.renderDays()),
    ];

    if (footer) tableChildren.push(footer);

    return DOM.div({ className: 'date-time-picker-days' }, DOM.table({}, tableChildren));
  }
}



// WEBPACK FOOTER //
// ./src/containers/date-time-picker/DaysView.js